/* "Eltern": everything about the Elternportal in one place (only when the add-on is on).
   Families and their invitations, what parents did lately, the rules. */
import { loggedIn, sbRest } from '../cloud/api.js';
import { PARENT_IC, hasAddon, openAddonSheet, parentsCfg } from '../cloud/addons.js';
import { parentAction, parentEmailsOf, syncParents } from '../cloud/parents.js';
import { fmtDM, fmtDate, today } from '../dates.js';
import { t } from '../i18n/index.js';
import { stuName } from '../model.js';
import { S } from '../state.js';
import { IC, RT, ask, avatarHtml, esc, render, toast } from '../ui.js';

let LINKS=null,loading=false,FILTER='all';
async function loadAll(){
  if(loading)return;loading=true;
  try{const r=await sbRest('parent_links?select=id,token,email,student_id,sent_at,last_seen_at&revoked_at=is.null&order=created_at');LINKS=r.ok?await r.json():[]}
  catch(e){LINKS=[]}
  finally{loading=false}
  if(RT.v==='parents')render();
}
export function invalidateParents(){LINKS=null}

const day=iso=>{const d=String(iso||'').slice(0,10);return d===today()?t('pl.today'):fmtDate(d)};
const ago30=()=>new Date(Date.now()-30*864e5).toISOString();
const stale=l=>l.sent_at&&!l.last_seen_at&&Date.parse(l.sent_at)<Date.now()-2*864e5;

export function vParents(){
  const head=`<div class="viewhead"><div><h1>${t('pp.title')}</h1><div class="sub">${t('pp.sub')}</div></div>`;
  if(!loggedIn()||!hasAddon('parents'))return head+`</div><div class="card parentsoff"><span class="pl-ic">${PARENT_IC}</span><div class="grow"><b>${t('addon.parents.title')}</b><p class="muted">${t('par.teaser')}</p></div><button class="btn primary" data-plo="addon">${t('addon.more')}</button></div>`;
  if(!LINKS){loadAll();return head+`</div><div class="card"><p class="muted">${t('pl.loading')}</p></div>`}

  const studs=S.students.filter(s=>!s.archived);
  const byStu=new Map();for(const l of LINKS){if(!byStu.has(l.student_id))byStu.set(l.student_id,[]);byStu.get(l.student_id).push(l)}
  const invited=LINKS.filter(l=>l.sent_at).length;
  const opened=LINKS.filter(l=>l.last_seen_at&&l.last_seen_at>ago30()).length;
  const never=LINKS.filter(l=>l.sent_at&&!l.last_seen_at).length;
  const noMail=studs.filter(s=>!parentEmailsOf(s).length&&!byStu.has(s.id));
  const nudge=LINKS.filter(stale);

  const rowsOf=s=>{
    const ls=byStu.get(s.id)||[];const emails=parentEmailsOf(s);
    const chips=ls.map(l=>{const st=l.last_seen_at?'on':l.sent_at?'sent':'new';
      const tip=l.last_seen_at?t('pl.seen',{d:day(l.last_seen_at)}):l.sent_at?t('pl.sent',{d:day(l.sent_at)})+', '+t('pl.notSeen'):t('pl.notSent');
      return `<span class="pchip ${st}" title="${esc(tip)}"><i></i>${esc(l.email||t('pl.legacy'))}<small>${esc(tip)}</small>${st!=='on'&&l.email?`<button type="button" class="pchip-act" data-pact="send" data-pl="${esc(l.id)}">${l.sent_at?t('pl.resend'):t('pl.send')}</button>`:''}</span>`}).join('');
    const pending=emails.filter(e=>!ls.some(l=>(l.email||'').toLowerCase()===e)).map(e=>`<span class="pchip new"><i></i>${esc(e)}<small>${t('pl.setup')}</small></span>`).join('');
    return `<div class="pfam" data-pfam="${ls.some(l=>l.last_seen_at)?'on':ls.length||emails.length?'never':'none'}">
      <button type="button" class="pfam-who" data-stu="${esc(s.id)}">${avatarHtml(s,'sm')}<b>${esc((s.first+' '+(s.last||'')).trim())}</b></button>
      <div class="pfam-par">${chips+pending||`<span class="muted">${t('pp.noMail')}</span> <button type="button" class="btn small" data-pedit="${esc(s.id)}">${IC.edit} ${t('pl.addEmail')}</button>`}</div>
    </div>`;
  };
  const list=studs.filter(s=>FILTER==='all'||(FILTER==='never'?(byStu.get(s.id)||[]).some(l=>!l.last_seen_at):FILTER==='none'?noMail.includes(s):true))
    .sort((a,b)=>a.first.localeCompare(b.first));

  // what parents did lately
  const act=S.sessions.filter(x=>(x.cancel&&x.cancel.by==='parent')||(x.booked&&x.booked.by==='parent'))
    .map(x=>({x,c:x.cancel&&x.cancel.by==='parent'&&x.status==='cancelled'?x.cancel:null,b:x.booked&&x.booked.by==='parent'?x.booked:null}))
    .map(o=>({...o,at:(o.c||o.b).at||''})).filter(o=>o.at>ago30()).sort((a,b)=>b.at.localeCompare(a.at)).slice(0,12);
  const actHtml=act.length?act.map(o=>{const unseen=!(o.c||o.b).seen;
    return `<div class="listrow click attn pact${unseen?' unseen':''}" data-evt="${esc(o.x.id)}"><span class="attn-ic${o.c?' red':''}">${o.c?IC.x:IC.cal}</span>
      <div class="grow"><div class="title">${esc(stuName(o.x.studentId))}</div><div class="meta">${o.c?t('pp.cancelled',{d:fmtDM(o.x.date)+', '+(o.x.time||'')}):t('pp.booked',{d:fmtDM(o.x.date)+', '+(o.x.time||'')})}${o.c&&o.c.late?', '+t('pcx.lateShort'):''}</div>
      <div class="meta">${esc(day(o.at))}${(o.c||o.b).who?', '+esc((o.c||o.b).who):''}</div></div>${IC.right}</div>`}).join('')
    :`<p class="muted emptyline">${t('pp.noActivity')}</p>`;

  const cfg=parentsCfg(),lateH=+(S.settings.lateCancelH??24);
  const rule=(on,txt)=>`<li class="${on?'on':''}">${on?IC.check:IC.x}<span>${txt}</span></li>`;
  const avail=Array.isArray(S.settings.avail)?S.settings.avail.length:0;

  return head+`<div class="headactions">${nudge.length?`<button class="btn" data-pnudge>${IC.mail} ${t('pp.nudge',{n:nudge.length})}</button>`:''}<button class="btn" data-set="plan">${t('pp.rulesBtn')}</button></div></div>
  <div class="statgrid">
    <div class="stat"><div class="v">${invited}</div><div class="l">${t('pp.k.invited')}</div></div>
    <div class="stat"><div class="v">${opened}</div><div class="l">${t('pp.k.opened')}</div></div>
    <div class="stat"><div class="v">${never}</div><div class="l">${t('pp.k.never')}</div></div>
    <div class="stat${noMail.length?' warnstat':''}"><div class="v">${noMail.length}</div><div class="l">${t('pp.k.noMail')}</div></div>
  </div>
  <div class="twocol">
    <div class="card">
      <div class="cardhead"><h2>${t('pp.families')}</h2>
        <div class="seg small" role="group">${[['all',t('pp.f.all')],['never',t('pp.f.never')],['none',t('pp.f.none')]].map(([k,l])=>`<button type="button" data-pf="${k}" class="${FILTER===k?'on':''}" aria-pressed="${FILTER===k}">${l}</button>`).join('')}</div></div>
      ${list.length?list.map(rowsOf).join(''):`<p class="muted emptyline">${t('pp.emptyFilter')}</p>`}
    </div>
    <div>
      <div class="card marge mb"><div class="cardhead"><h2>${t('pp.activity')}</h2><span class="tiny">${t('school.last7').replace(/7/,'30')}</span></div>${actHtml}</div>
      <div class="card"><div class="cardhead"><h2>${t('pp.rules')}</h2><button class="btn small ghost" data-set="plan">${t('c.edit')}</button></div>
        <ul class="prules">
          ${rule(cfg.invite,t('addon.rule.invite'))}
          ${rule(cfg.report,t('addon.rule.report'))}
          ${rule(cfg.cancel,t('addon.rule.cancel'))}
          ${rule(cfg.cancel&&cfg.lateBill,t('addon.rule.lateBill',{h:lateH}))}
          ${rule(cfg.makeup&&avail>0,t('addon.rule.makeup'))}
        </ul>
        ${cfg.makeup&&!avail?`<div class="prules-fix"><p>${t('pp.noAvail')}</p><button class="btn small" data-set="teaching">${IC.plus} ${t('avail.add')}</button></div>`:''}
      </div>
    </div>
  </div>`;
}

export function bindParents(m,openEditor){
  if(RT.v!=='parents')return;
  m.querySelectorAll('[data-pf]').forEach(b=>b.onclick=()=>{FILTER=b.dataset.pf;render()});
  m.querySelectorAll('[data-pedit]').forEach(b=>b.onclick=()=>openEditor(b.dataset.pedit));
  m.querySelectorAll('[data-pact]').forEach(b=>b.onclick=async e=>{e.stopPropagation();b.disabled=true;
    try{await parentAction(b.dataset.pl,'send');toast(t('pl.sentNow'));LINKS=null;render()}catch(err){toast(t('plan.err'));b.disabled=false}});
  const nb=m.querySelector('[data-pnudge]');
  if(nb)nb.onclick=()=>{const list=(LINKS||[]).filter(stale);
    ask(t('pp.nudgeAsk',{n:list.length}),async()=>{nb.disabled=true;let n=0;
      for(const l of list){try{await parentAction(l.id,'send');n++}catch(e){}}
      toast(t('pp.nudged',{n}));LINKS=null;render()})};
  // keep it fresh: new parent emails get their links, then reload
  if(LINKS&&!m._synced){m._synced=1;syncParents().then(d=>{if(d&&(d.created||d.sent||d.revoked)){LINKS=null;render()}})}
}
